import { csx } from '@vtex/admin-ui'

export const icon = csx({
  height: '36px !important',
  width: '44px',
  transition: 'all 200ms',
  color: '$secondary',
  padding: '$space-2',
  borderRadius: '4px',

  '> span': {
    display: 'inline-block',
  },

  ':hover': {
    backgroundColor: 'var(--admin-ui-bg-action-neutral-tertiaryPressed)',
  },

  svg: {
    transition: 'all 400ms',
    margin: '0 auto',

    '[data-status="closed"]': {
      transform: 'rotate(180deg)',
    },
  },
})

export const container = csx({
  position: 'fixed',
  width: '21.875rem',
  height: 'auto',
  display: 'flex',
  bottom: '0.563rem',
  backgroundColor: 'var(--admin-ui-fg-white)',
  border: '1px solid #DDD',
  flexDirection: 'column',
  right: '1.125rem',
  margin: '1.875rem',
  zIndex: 111,
  boxShadow: 'var(--admin-ui-shadow-overlay-center)',
  borderRadius: '0.25rem',
  maxHeight: '60vh',
})

export const collapserTitle = csx({
  display: 'flex',
  justifyContent: 'space-between',
  cursor: 'pointer',
  padding: '$space-2 $space-2 $space-2 $space-5',
  backgroundColor: 'var(--admin-ui-bg-gray05)',
  maxHeight: '2.75rem',
  borderRadius: '0.22rem 0.22rem 0 0',
  boxSizing: 'unset',
})

export const content = csx({
  overflow: 'hidden auto',
  height: '0',
  transition: 'height 400ms ease-out',
  '[data-open="true"]': {
    height: 'auto',
  },
})
